import ChatInbox from "./Inbox/index";

const Chat = () => {
  return <ChatInbox />;
};

export default Chat;
